<template>
  <div class="empty-state">
    <div class="empty-state__icon">
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="6" width="32" height="36" rx="4" stroke="currentColor" stroke-width="1.5"/>
        <path d="M16 18h16M16 24h10M16 30h13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="36" cy="36" r="10" fill="var(--empty-circle, #f5f5f5)" stroke="currentColor" stroke-width="1.5"/>
        <path d="M33 33l6 6M39 33l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
    <p class="empty-state__title">{{ title || $t('No results found') }}</p>
    <p v-if="subtitle" class="empty-state__sub">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
  },
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 24px;
  text-align: center;
}
.empty-state__icon {
  width: 56px;
  height: 56px;
  color: #c4c7cf;
  margin-bottom: 16px;
  --empty-circle: #f5f5f5;
}
.empty-state__icon svg {
  width: 100%;
  height: 100%;
}
.empty-state__title {
  font-size: 15px;
  font-weight: 600;
  color: #6b7280;
  margin: 0;
}
.empty-state__sub {
  font-size: 13px;
  font-weight: 400;
  color: #9ca3af;
  margin: 6px 0 0;
}

/* Dark theme */
.theme--dark .empty-state__icon {
  color: #4a4c5a;
  --empty-circle: #22232e;
}
.theme--dark .empty-state__title {
  color: #8b8d9e;
}
.theme--dark .empty-state__sub {
  color: #5a5c6a;
}
</style>
